import React from 'react';
import { InfoIcon } from '../../ui/Icons';

export const InfoNotice: React.FC = () => {
  return (
    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
      <div className="flex items-start gap-3">
        <InfoIcon className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5" />
        <div>
          <h4 className="font-medium text-blue-800 dark:text-blue-200 mb-1">
            Management API Limitations
          </h4>
          <ul className="text-sm text-blue-700 dark:text-blue-300 space-y-0.5">
            <li>• Usage data (requests, cost) is not available via Management API</li>
            <li>• User activity is estimated from the last used date of API keys</li>
            <li>• For detailed usage analysis, please use the Usage Dashboard</li>
          </ul>
        </div>
      </div>
    </div>
  );
};
